import React from 'react';

const WhyChooseSection = () => {
    const hospitalFeatures = [
        {
            title: 'Centralized Hospital Operations',
            description: "You'll have access to confidential, professional guidance for challenges that may arise including anxiety, depression, grief, relationship challenges, or legal and financial concerns."
        },
        {
            title: 'Faster Patient Management',
            description: "You'll have access to confidential, professional guidance for challenges that may arise including anxiety, depression, grief, relationship challenges, or legal and financial concerns."
        },
        {
            title: 'Improved Staff Productivity',
            description: "You'll have access to confidential, professional guidance for challenges that may arise including anxiety, depression, grief, relationship challenges, or legal and financial concerns."
        },
        {
            title: 'Simplified Billing Process',
            description: "You'll have access to confidential, professional guidance for challenges that may arise including anxiety, depression, grief, relationship challenges, or legal and financial concerns."
        },
        {
            title: 'Accurate Pharmacy Inventory',
            description: "You'll have access to confidential, professional guidance for challenges that may arise including anxiety, depression, grief, relationship challenges, or legal and financial concerns."
        }
    ];

    return (
        <section className="w-full max-w-[1440px] mx-auto py-16 lg:py-24 select-none">
            <div className="flex lg:flex-row flex-col lg:gap-[92px] gap-[30px] items-start px-[20px] lg:px-[80px]">
                <div className="md:max-w-[446px] w-full sticky top-32 self-start">
                    <h2 className="text-[20px] sm:text-[30px] font-sora font-[600] text-[#01386A] tracking-tight leading-tight">
                        Why Choose our Hospital Management System?
                    </h2>
                </div>

                <div className="md:max-w-[742px] w-full flex flex-col gap-6">
                    {hospitalFeatures.map((feature, index) => (
                        <div
                            key={index}
                            className={`group flex flex-col p-[24px] bg-white border-x border-t transition-all duration-300 relative border-[#01386A45] border-b-[4px] border-b-[#01386A] hover:border-b-orange-500`}
                        >
                            <div className="flex flex-row items-start gap-[30px] mb-[20px]">
                                <div className="w-full max-w-[258px] h-[140px] bg-slate-900 flex-shrink-0 relative overflow-hidden">
                                    <img
                                        src={`/assets/hospital/feature-${index + 1}.png`}
                                        alt={feature.title}
                                        className="w-full h-full object-cover"
                                    />
                                </div>

                                <h3 className="text-[16px] lg:text-[20px] font-[600] max-w-[250px] text-[#01386A] font-sora tracking-tight leading-tight">
                                    {feature.title}
                                </h3>
                            </div>

                            <p className="text-[14px] lg:text-[16px] font-graphik font-[500] text-[#49577A] leading-relaxed text-left">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default WhyChooseSection;